import { createTheme } from "@mui/material";

declare module "@mui/material/styles" {
  interface PaletteOptions {
    neutral?: Palette["primary"];
    neutralLight?: Palette["primary"];
  }

  interface Palette {
    neutral?: Palette["primary"];
    neutralLight?: Palette["primary"];
  }
}

declare module "@mui/material/Button" {
  interface ButtonPropsColorOverrides {
    neutral?: true;
    neutralLight?: true;
  }
}

export const cmsTheme: any = createTheme({
  shape: {
    borderRadius: 12,
  },
  typography: {
    fontFamily: "Inter, sans-serif",
    fontWeightLight: 400,
    fontWeightRegular: 500,
    fontWeightMedium: 600,
    fontWeightBold: 700,
    display: {
      fontWeight: 700,
      fontSize: 32,
      lineHeight: "120%",
    },
    h1: {
      fontWeight: 600,
      fontSize: 24,
      lineHeight: "130%",
    },
    h2: {
      fontWeight: 600,
      fontSize: 20,
      lineHeight: "140%",
    },
    h3: {
      fontWeight: 600,
      fontSize: 18,
      lineHeight: "140%",
    },
    subtitle1: {
      fontWeight: 400,
      fontSize: 16,
      lineHeight: "160%",
    },
    body1: {
      fontWeight: 400,
      fontSize: 14,
      lineHeight: "160%",
    },
    body2: {
      fontWeight: 400,
      fontSize: 12,
      lineHeight: "150%",
    },
    body3: {
      fontWeight: 400,
      fontSize: 11,
      lineHeight: "140%",
    },
  },
  palette: {
    primary: {
      main: "#181C62",
    },
    neutral: {
      main: "#818194",
      contrastText: "#FFFFFF",
      dark: "#6a6a7a",
      light: "#9494a8",
    },
    neutralLight: {
      main: "#f5f5f5",
      contrastText: "#1F2A37",
      dark: "#e0dede",
      light: "#f5f5f5",
    },
    text: {
      primary: "#111928",
    },
    divider: "#e5e7eb",
  },
});
